<template>
    <div>
		<navBar/>
        <banner titulo="Gerenciar Agendamentos" subTitulo="Agenda/Solicitações"/>
        <div class="borda d-flex flex-column w-75 mx-auto justify-content-start p-3 gap-md">
  			<b-card no-body>
    			<b-tabs card fill @input="handleInicializarValores">
      				<b-tab title="Agenda" active>
        				<b-card-text><agenda ref="agenda"/></b-card-text>
      				</b-tab>
      				<b-tab title="Solicitações">
        				<b-card-text><solicitacoes ref="solicitacoes"/></b-card-text>
      				</b-tab>
    			</b-tabs>
  			</b-card>
		</div>
	</div>
</template>

<script>
import NavBar from "../../components/shared/NavBar.vue";
import Banner from "../../components/shared/Banner.vue";
import Agenda from "../../components/Agendamento/Agenda.vue";
import Solicitacoes from "../../components/Agendamento/Solicitacoes.vue";


export default{
	name: "GerenciarAgendamentos",
	components: {
		navBar: NavBar,
		banner: Banner,
		agenda: Agenda,
		solicitacoes: Solicitacoes,
	},
	data() {
		return {

		};
	},
	methods: {
		handleInicializarValores() {
			this.$refs.agenda.inicializarValores();
			this.$refs.solicitacoes.filtrarAgendamentos();
		},
	},
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/agendamento/GerenciarAgendamentos.vue